import { Component, HostListener, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LeadService } from '../../../service/lead.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-mobile-premium-cal-details',
  imports: [TranslatePipe,CommonModule,ReactiveFormsModule],
  templateUrl: './mobile-premium-cal-details.component.html',
  styleUrl: './mobile-premium-cal-details.component.scss'
})
export class MobilePremiumCalDetailsComponent {
  // ---------- Constructor ----------
  constructor(private leadService: LeadService,private router: Router,
      private _actRoute: ActivatedRoute
  ) {}

  // To store response data
  responseData!:number| null;

    /** Current query */
  private currentQueryParams: any = {};

  /** Current language */
  private currentLang!: string ;

  // Angualr Hooks
  ngOnInit() {
    this.responseData = this.leadService.getResponseData();
     this.currentLang = this.router.url.split('/')[1]; // 0: "income-protection-insurance", 1: "vi"
    console.log('Lang from ActivatedRoute:', this.currentLang);
    this._actRoute.queryParams.subscribe((queryParams) => {
      this.currentQueryParams = { ...queryParams };
    });
  }
  // Get coverage navigation
  onCoverage() {
    const basePath = [this.router.url.split('/')[2]];
    this.router.navigate([this.currentLang, ...basePath,'mobile-premium-form'], {
      queryParams: {
         ...this.currentQueryParams
      }
    });
  }
}
